import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const INDICATOR_COLOR = {
	GREEN: 'green',
	BLUE: 'blue',
	GREY: 'grey',
	RED: 'red',
	AMBER: 'amber',
};

/** Single source of truth for status colour tokens. Import this wherever you need bg/fg/border for a given INDICATOR_COLOR. */
export const INDICATOR_COLOR_STYLES = {
	[INDICATOR_COLOR.GREEN]: {bg: '#E1FAED', border: '#00BF5F', fg: '#00BF5F'},
	[INDICATOR_COLOR.BLUE]: {bg: '#E2F1FF', border: '#008EFF', fg: '#008EFF'},
	[INDICATOR_COLOR.RED]: {bg: '#FEE2E2', border: '#EF4444', fg: '#B91C1C'},
	[INDICATOR_COLOR.AMBER]: {bg: '#FEF3C7', border: '#F59E0B', fg: '#92400E'},
	[INDICATOR_COLOR.GREY]: {bg: '#F7F7FE', border: '#E6E6ED', fg: '#4C4C58'},
};

const getColoredStyle = color => {
	const s = INDICATOR_COLOR_STYLES[color] ?? INDICATOR_COLOR_STYLES[INDICATOR_COLOR.GREY];
	return {backgroundColor: s.bg, border: `1px solid ${s.border}`, color: s.fg};
};

const ApprovalStatusIndicator = styled.div`
	display: flex;
	border-radius: 22px;
	padding: 8px 12px;
	margin-left: 8px;
	font-size: 10px;
	line-height: 10px;
	font-weight: 500;
	${props => getColoredStyle(props.color)}
`;

const HeaderLabel = ({text, color}) => {
	return <ApprovalStatusIndicator color={color}>{text}</ApprovalStatusIndicator>;
};

HeaderLabel.INDICATOR_COLOR = INDICATOR_COLOR;

HeaderLabel.propTypes = {
	text: PropTypes.string.isRequired,
	color: PropTypes.oneOf(Object.values(INDICATOR_COLOR)).isRequired,
};

HeaderLabel.defaultProps = {
	color: INDICATOR_COLOR.GREY,
};

export default HeaderLabel;
